// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportGetOptInWithCreditTrackingHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  RentCreditReportGetOptInWithCreditTrackingWebApiRequestDto,
  RentCreditReportGetOptInWithCreditTrackingWebApiResponseDto,
} from '../..';

export const RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_Path =
  '/api/web/v1/rentCreditReport/getOptInWithCreditTracking';

/**
 * Get opt in status for rent reporting with credit tracking
 */
export const RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking = (
  postData: RentCreditReportGetOptInWithCreditTrackingWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RentCreditReportGetOptInWithCreditTrackingWebApiRequestDto,
    RentCreditReportGetOptInWithCreditTrackingWebApiResponseDto
  >(
    {
      endpoint: RentCreditReportGetOptInWithCreditTrackingHandler_getOptInWithCreditTracking_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
